<template>
  <div class="head">
    <div class="headt clearfix">
      <div class="logo">
        <a href="/" title>
          <img src="/static/logo1.png" />
          <img src="/static/logo2.png" />
        </a>
      </div>
      <div class="logotit ft28">宝钢金属有限公司</div>

      <div class="luang">
        <a href="#" title>中</a>
        <a href="#" title>EN</a>
      </div>
      <div class="ssan">
        <a href="javascript:;" title @click="showSearch">
          <img src="/static/headico2.png" />
          <img src="/static/headico2_.png" />
        </a>
      </div>
      <div class="navlin" @click="phoneMenuFlag=!phoneMenuFlag" :class="phoneMenuFlag?'cur':''">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="headcon">
      <div class="cons clearfix">
        <div class="nav" :style="{display:phoneMenuFlag?'block':'none'}">
          <ul class="clearfix">
            <li>
              <a href="/" title class="yj">首页</a>
            </li>
            <li v-for="nav in menuList" :key="nav.nodeId" :style="{display:nav.isShow>0?'':'none'}">
              <a
                :style="{color:!$utils.isMobile()&&colorFlag>1?'#003586':'#fff'}"
                v-if="nav.nodeIndexName=='product'"
                :href="nav.linkUrl"
                target="_blank"
                title
                class="yj"
              >{{nav.nodeName}}</a>
              <router-link
                v-if="nav.nodeIndexName!='product'"
                :style="{color:!$utils.isMobile()&&colorFlag>1?'#003586':'#fff'}"
                :to="{name:nav.pathName,params:{pId:nav.nodeId,cId:nav.hasChilds?nav.childs[0].nodeId:''}}"
                class="yj"
                :class="$route.name==$utils.getPathByNodeIndexName(nav.nodeIndexName).name?'cur':''"
              >{{nav.nodeName}}</router-link>

              <div class="ej clearfix" v-if="nav.childs&&nav.childs.length>0">
                <router-link
                  v-for="cell in nav.childs"
                  :key="cell.nodeId"
                  :to="{name:nav.pathName,params:{pId:nav.nodeId,cId:cell.nodeId}}"
                  title
                >{{cell.nodeName}}</router-link>
              </div>
            </li>
          </ul>
        </div>
        <div class="right" :style="{display:phoneSearchFlag?'block':'none'}">
          <div class="sous clearfix">
            <form>
              <input
                :style="{borderColor:phoneSearchFlag?'#fff':'#003586'}"
                v-model="searchVal"
                class="txt"
              />
              <input
                type="button"
                :style="{color:phoneSearchFlag?'#fff':'#003586'}"
                @click="searchFun"
                class="but"
                value="搜索"
              />
            </form>
          </div>

          <div class="luang">
            <a href="#" title>中</a>
            <a href="#" title>EN</a>
          </div>
          <div class="ygrk">
            <a href="http://Vpn.baosteel.com" target="_blank">员工入口</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMenu } from "@/api/index";
export default {
  data() {
    return {
      menuList: [],
      searchVal: "",
      phoneSearchFlag: true,
      phoneMenuFlag: false,
      colorFlag: 1 //1 白色，2 彩色
    };
  },
  created() {
    this.showSearch();
    if (!localStorage.bwsteelMenus) {
      this.getMenuFun();
    } else {
      let menus = JSON.parse(localStorage.bwsteelMenus);
      this.$set(this.$data, "menuList", menus);
    }
  },
  methods: {
    getMenuFun() {
      getMenu().then(res => {
        if (res.data.code === 1000) {
          let datas = res.data.data[0].childs.map(item => {
            if (item.childs) {
              item.hasChilds = true;
            }
            item.path = this.$utils.getPathByNodeIndexName(
              item.nodeIndexName
            ).url;
            item.pathName = this.$utils.getPathByNodeIndexName(
              item.nodeIndexName
            ).name;
            return item;
          });
          localStorage.setItem("bwsteelMenus", JSON.stringify(datas));
          this.$set(this.$data, "menuList", datas);
        } else {
          this.$message.error("栏目获取失败！");
        }
      });
    },
    showSearch() {
      if (this.$utils.isMobile()) {
        this.phoneSearchFlag = !this.phoneSearchFlag;
      } else {
        this.phoneSearchFlag = true;
      }
    },
    searchFun() {
      if (!this.searchVal) {
        this.$alert("请输入搜索关键字！", "信息", {
          confirmButtonText: "确定"
        });
      } else {
        this.$router.push({ name: "search", query: { key: this.searchVal } });
      }
    }
  }
};
</script>